import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaKitaClubFlyer({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.flyer_distribution) {
      errors.flyer_distribution = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (validateForm()) {
      if (primaryDetails.flyer_distribution === "Yes") {
        navigation.go("maya-kita-club-flyer-photo");
      } else {
        navigation.go("troubleshoot-qr-sticker");
      }
    } else {
      toast.error("Please select Yes or No.");
    }
  };

  const handleBack = (e) => {
    navigation.previous();
  };

  const options = ["Yes", "No"];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">MAYA KITA CLUB FLYER</h4>
              <p className="form-desc">
                Nagbigay ka ba ng MAYA Kita Club flyer?
              </p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Flyer Question */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Nagbigay ka ba ng MAYA Kita Club flyer?
                      <span className="form-required">*</span>
                    </Form.Label>
                    <div
                      className={`form-radio-group ${
                        isError.flyer_distribution
                          ? "form-group-error"
                          : ""
                      }`}
                    >
                      {options.map((option) => (
                        <div key={option} className="form-radio-item">
                          <Form.Check
                            type="radio"
                            id={`maya_kita_${option.toLowerCase()}`}
                            name="flyer_distribution"
                            value={option}
                            checked={
                              primaryDetails.flyer_distribution ===
                              option
                            }
                            onChange={handleInputChange}
                            label={option}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                    {isError.flyer_distribution && (
                      <div className="form-error">
                        Please select Yes or No.
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaKitaClubFlyer;
